import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Table } from '@react-apps/design-system';
import type { ColumnDef } from '@react-apps/design-system';
import type { SubjectView } from '../../domain/entities/content.entity';
import { useSubjectViews } from '../hooks/use-subject-views';
import { useCanWriteSubjects } from '../hooks/use-content-permissions';
import { Mono } from '../display';
import { CreateSubjectViewModal } from './CreateSubjectViewModal';
import { RefreshButton } from '@/shared/RefreshButton';

const columns: ColumnDef<SubjectView>[] = [
  {
    key: 'name',
    header: 'Nome',
    render: (row) => (
      <span className="text-(--color-text-primary) font-medium">
        {row.name}
      </span>
    ),
  },
  {
    key: 'tenant',
    header: 'Tenant',
    render: (row) => <Mono>{row.tenant}</Mono>,
  },
  { key: 'id', header: 'ID', render: (row) => <Mono>{row.id}</Mono> },
];

export function SubjectViewsPanel() {
  const navigate = useNavigate();
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const { data, isLoading, refetch, isFetching } = useSubjectViews();
  const canWrite = useCanWriteSubjects();

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <p className="text-(--color-text-secondary) text-sm">
          Visões e seus assuntos. Clique numa visão para gerenciar os membros.
        </p>
        <div className="flex shrink-0 items-center gap-2">
          <RefreshButton
            onRefresh={() => void refetch()}
            isRefreshing={isFetching}
          />
          {canWrite && (
            <Button onClick={() => setIsCreateOpen(true)}>Criar visão</Button>
          )}
        </div>
      </div>

      <Table
        columns={columns}
        data={data ?? []}
        keyExtractor={(row) => row.id}
        loading={isLoading}
        emptyMessage="Nenhuma visão encontrada."
        striped
        onRowClick={(row) => void navigate(`/content/views/${row.id}`)}
      />

      <CreateSubjectViewModal
        open={isCreateOpen}
        onClose={() => setIsCreateOpen(false)}
      />
    </div>
  );
}
